<script>
  import {
  orgComputed,
  orgMethods
} from '@state/helpers';

export default {
  methods: {
    ...orgMethods
  },
  computed: {
    ...orgComputed,
    colors() {
      return {
        '--color':  this.primaryColor
      }
    }
  },
};
</script>

<template>
  <div class="loading" :style="colors">
    <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg" v-bind:class="'spinner'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M502.121 1.215c-5.973-2.453-12.863-1.11-17.43 3.476l-57.597 57.602C379.605 23.082 318.676 0 256 0 114.836 0 0 114.836 0 256s114.836 256 256 256c68.332 0 132.61-26.645 180.969-75.031 8.344-8.34 8.344-21.82 0-30.164-8.34-8.34-21.82-8.34-30.164 0-40.297 40.32-93.868 62.527-150.805 62.527-117.633 0-213.332-95.7-213.332-213.332S138.368 42.668 256 42.668c51.414 0 101.332 18.496 140.777 49.918l-50.75 50.773a16.02 16.02 0 00-3.476 17.43 15.993 15.993 0 0014.781 9.879H496c8.832 0 16-7.168 16-16V16a15.996 15.996 0 00-9.879-14.785zm0 0"/></svg>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}
@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}
// @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
.loading {
  align-content: center;
  display: flex;
  height: 100%;
  justify-content: center;
  max-height: 4rem;
  max-width: 4rem;
  width: 100%;
  .spinner {
    -webkit-animation: spin 2s linear infinite;
    -moz-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    font-size: 2rem;
    font-weight: 900;
    height: 100%;
    margin: auto;
    position: relative;
    width: 100%;
    path {
      fill: var(--color);
    }
  }
}
</style>
